module.exports = __webpack_public_path__ + "img/orchestra.f333cb82.jpg";